export enum MIXPANEL_EVENT {
  DISCORD_OPEN = 'DISCORD_OPEN',
  TWITTER_OPEN = 'TWITTER_OPEN',
  ABOUT_US_OPEN = 'ABOUT_US_OPEN',
  WALLET_SIGNUP_SUCCESS = 'WALLET_SIGNUP_SUCCESS',
  GOOGLE_SIGNUP_SUCCESS = 'GOOGLE_SIGNUP_SUCCESS',
  QUEST_COMPLETED = 'QUEST_COMPLETED',
}
